import "./DropdownSelector.css";
import Select from "react-select";

const customStyles = {
  container: (provided) => ({
    ...provided,
    boxShadow: "0px 4px 6px 0px #c3c3c3",
  }),
  control: (provided, state) => ({
    ...provided,
    height: "25px",
    minHeight: "25px",
    fontSize: "13px",
    fontWeight: 600,
    backgroundColor: state.isDisabled ? "#909094" : "#f7f7f7",
    borderWidth: "0px",
    borderRadius: "0px",
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: 0,
    paddingLeft: 0,
    fontSize: "13px",
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    padding: 0,
    paddingRight: 2,
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "#333333",
    paddingLeft: 5,
    marginLeft: 0,
  }),
  menu: (provided) => ({
    ...provided,
    fontSize: "13px",
    zIndex: 1000,
  }),
  indicatorsContainer: (provided, state) => ({
    ...provided,
    color: state.isDisabled ? "#909094" : "#333333",
    fill: state.isDisabled ? "#909094" : "#333333",
    svg: {
      fill: "black",
    },
  }),
  option: (provided, state) => {
    return {
      ...provided,
      backgroundColor: state.isSelected
        ? "#49B970"
        : state.isFocused
        ? "#D8E5DE"
        : "#F7F7F7",
      ":active": {
        ...provided[":active"],
        backgroundColor: state.isSelected ? "#49B970" : "#49B970",
        color: state.isSelected ? "#ffffff" : "#ffffff",
      },
    };
  },
};

const DropdownSelector = ({
  header = "Header",
  options = [],
  value,
  changeSelection,
  isDisabled,
}) => {
  return (
    <>
      <div className="selector__header">{header}</div>
      <Select
        styles={customStyles}
        options={options}
        value={value}
        isSearchable={true}
        onChange={changeSelection}
        isDisabled={isDisabled}
        width="200px"
      />
    </>
  );
};

export default DropdownSelector;
